"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailTemplates = void 0;
var _react = _interopRequireWildcard(require("react"));
var _dmsbasereact = require("dmsbasereact");
var _material = require("@mui/material");
var _Edit = _interopRequireDefault(require("@mui/icons-material/Edit"));
var _Save = _interopRequireDefault(require("@mui/icons-material/Save"));
var _Cancel = _interopRequireDefault(require("@mui/icons-material/Cancel"));
var _Visibility = _interopRequireDefault(require("@mui/icons-material/Visibility"));
var _sweetalert = _interopRequireDefault(require("sweetalert2"));
const _excluded = ["children", "value", "index"];
/**
 * @fileoverview EmailTemplates - Management UI for email templates
 * Allows administrators to view and edit email templates stored in the database
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Tab panel component for the edit modal
 */
const TabPanel = _ref => {
  let {
      children,
      value,
      index
    } = _ref,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    role: "tabpanel",
    hidden: value !== index,
    id: "template-tabpanel-".concat(index),
    "aria-labelledby": "template-tab-".concat(index)
  }, other), value === index && /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      p: 2
    }
  }, children));
};

/**
 * Template list item component
 */
const TemplateListItem = _ref2 => {
  let {
    template,
    onEdit
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.ListItem, null, /*#__PURE__*/_react.default.createElement(_material.ListItemText, {
    primary: /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: {
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "subtitle1",
      fontWeight: "bold"
    }, template.template_name), /*#__PURE__*/_react.default.createElement(_material.Chip, {
      label: template.template_key,
      size: "small",
      variant: "outlined",
      color: "primary"
    })),
    secondary: /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: {
        mt: 0.5
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "body2",
      color: "text.secondary"
    }, template.description || _dmsbasereact.intl.get('NoDescription').d('No description')), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "caption",
      color: "text.secondary",
      sx: {
        mt: 0.5,
        display: 'block'
      }
    }, _dmsbasereact.intl.get('Subject').d('Subject'), ": ", template.subject))
  }), /*#__PURE__*/_react.default.createElement(_material.ListItemSecondaryAction, null, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    edge: "end",
    "aria-label": "edit",
    onClick: () => onEdit(template),
    title: _dmsbasereact.intl.get('EditTemplate').d('Edit Template')
  }, /*#__PURE__*/_react.default.createElement(_Edit.default, null)))), /*#__PURE__*/_react.default.createElement(_material.Divider, {
    component: "li"
  }));
};

/**
 * Edit modal component for email templates
 */
const EditTemplateModal = _ref3 => {
  let {
    open,
    template,
    onClose,
    onSave
  } = _ref3;
  const [tabValue, setTabValue] = (0, _react.useState)(0);
  const [formData, setFormData] = (0, _react.useState)({
    subject: '',
    html_template: '',
    text_template: ''
  });
  const [preview, setPreview] = (0, _react.useState)(null);
  const [previewLoading, setPreviewLoading] = (0, _react.useState)(false);
  const [saving, setSaving] = (0, _react.useState)(false);

  // Initialize form data when template changes
  (0, _react.useEffect)(() => {
    if (template) {
      setFormData({
        subject: template.subject || '',
        html_template: template.html_template || '',
        text_template: template.text_template || ''
      });
      setPreview(null);
      setTabValue(0);
    }
  }, [template]);
  const handleFieldChange = (field, value) => {
    setFormData(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [field]: value
    }));
  };
  const handlePreview = async () => {
    if (!template) return;
    setPreviewLoading(true);
    try {
      // Build sample data from template variables
      const sampleData = {};
      if (template.variables && Array.isArray(template.variables)) {
        template.variables.forEach(varName => {
          sampleData[varName] = "[".concat(varName, "]");
        });
      }
      const response = await (0, _dmsbasereact.fetchData)("/email-templates/".concat(template.template_key, "/preview"), 'POST', true, {
        sample_data: sampleData
      }, false, true);
      if (response.status === _dmsbasereact.HTTP_STATUS.OK_200) {
        setPreview(response.data);
        setTabValue(3); // Switch to preview tab
      } else {
        var _response$data;
        _sweetalert.default.fire({
          icon: 'error',
          title: _dmsbasereact.intl.get('PreviewError').d('Preview Error'),
          text: ((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.detail) || _dmsbasereact.intl.get('FailedToGeneratePreview').d('Failed to generate preview')
        });
      }
    } catch (error) {
      _sweetalert.default.fire({
        icon: 'error',
        title: _dmsbasereact.intl.get('PreviewError').d('Preview Error'),
        text: error.message
      });
    } finally {
      setPreviewLoading(false);
    }
  };
  const handleSave = async () => {
    if (!template) return;
    const result = await _sweetalert.default.fire({
      title: _dmsbasereact.intl.get('ConfirmSave').d('Confirm Save'),
      text: _dmsbasereact.intl.get('ConfirmSaveTemplateMessage').d('Are you sure you want to save the template changes?'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: _dmsbasereact.intl.get('Confirm').d('Confirm'),
      cancelButtonText: _dmsbasereact.intl.get('Cancel').d('Cancel')
    });
    if (!result.isConfirmed) return;
    setSaving(true);
    try {
      const response = await (0, _dmsbasereact.fetchData)("/email-templates/".concat(template.pk), 'PUT', true, formData, false, true);
      if (response.status === _dmsbasereact.HTTP_STATUS.OK_200) {
        _sweetalert.default.fire({
          icon: 'success',
          title: _dmsbasereact.intl.get('TemplateSaved').d('Template Saved'),
          text: _dmsbasereact.intl.get('TemplateUpdatedSuccessfully').d('Email template updated successfully')
        });
        onSave();
      } else {
        var _response$data2;
        _sweetalert.default.fire({
          icon: 'error',
          title: _dmsbasereact.intl.get('SaveError').d('Save Error'),
          text: ((_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.detail) || _dmsbasereact.intl.get('FailedToSaveTemplate').d('Failed to save template')
        });
      }
    } catch (error) {
      _sweetalert.default.fire({
        icon: 'error',
        title: _dmsbasereact.intl.get('SaveError').d('Save Error'),
        text: error.message
      });
    } finally {
      setSaving(false);
    }
  };
  if (!template) return null;
  return /*#__PURE__*/_react.default.createElement(_material.Modal, {
    open: open,
    onClose: onClose,
    "aria-labelledby": "edit-template-modal-title"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '90%',
      maxWidth: 900,
      maxHeight: '90vh',
      bgcolor: 'background.paper',
      border: '1px solid #ccc',
      borderRadius: 2,
      boxShadow: 24,
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      p: 2,
      borderBottom: '1px solid #eee'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    id: "edit-template-modal-title",
    variant: "h6"
  }, _dmsbasereact.intl.get('EditEmailTemplate').d('Edit Email Template')), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body2",
    color: "text.secondary"
  }, template.template_name, " (", template.template_key, ")")), template.variables && template.variables.length > 0 && /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      px: 2,
      py: 1,
      bgcolor: 'grey.50'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "caption",
    color: "text.secondary"
  }, _dmsbasereact.intl.get('AvailableVariables').d('Available variables'), ":", ' ', template.variables.map(v => /*#__PURE__*/_react.default.createElement(_material.Chip, {
    key: v,
    label: "{{".concat(v, "}}"),
    size: "small",
    sx: {
      mr: 0.5,
      mb: 0.5
    }
  })))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      borderBottom: 1,
      borderColor: 'divider'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Tabs, {
    value: tabValue,
    onChange: (e, v) => setTabValue(v)
  }, /*#__PURE__*/_react.default.createElement(_material.Tab, {
    label: _dmsbasereact.intl.get('Subject').d('Subject')
  }), /*#__PURE__*/_react.default.createElement(_material.Tab, {
    label: _dmsbasereact.intl.get('HTMLTemplate').d('HTML Template')
  }), /*#__PURE__*/_react.default.createElement(_material.Tab, {
    label: _dmsbasereact.intl.get('TextTemplate').d('Text Template')
  }), /*#__PURE__*/_react.default.createElement(_material.Tab, {
    label: _dmsbasereact.intl.get('Preview').d('Preview')
  }))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      flexGrow: 1,
      overflow: 'auto'
    }
  }, /*#__PURE__*/_react.default.createElement(TabPanel, {
    value: tabValue,
    index: 0
  }, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTextField, {
    name: "subject",
    label: _dmsbasereact.intl.get('EmailSubject').d('Email Subject'),
    fullWidth: true,
    value: formData.subject,
    onChange: e => handleFieldChange('subject', e.target.value),
    helperText: _dmsbasereact.intl.get('SubjectHelperText').d('Use {{variable}} syntax for dynamic content')
  })), /*#__PURE__*/_react.default.createElement(TabPanel, {
    value: tabValue,
    index: 1
  }, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTextField, {
    name: "html_template",
    label: _dmsbasereact.intl.get('HTMLContent').d('HTML Content'),
    fullWidth: true,
    multiline: true,
    rows: 15,
    value: formData.html_template,
    onChange: e => handleFieldChange('html_template', e.target.value),
    helperText: _dmsbasereact.intl.get('HTMLHelperText').d('HTML version of the email body. Use {{variable}} for placeholders.'),
    sx: {
      '& .MuiInputBase-input': {
        fontFamily: 'monospace',
        fontSize: '0.875rem'
      }
    }
  })), /*#__PURE__*/_react.default.createElement(TabPanel, {
    value: tabValue,
    index: 2
  }, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTextField, {
    name: "text_template",
    label: _dmsbasereact.intl.get('TextContent').d('Text Content'),
    fullWidth: true,
    multiline: true,
    rows: 15,
    value: formData.text_template,
    onChange: e => handleFieldChange('text_template', e.target.value),
    helperText: _dmsbasereact.intl.get('TextHelperText').d('Plain text version of the email body. Use {{variable}} for placeholders.'),
    sx: {
      '& .MuiInputBase-input': {
        fontFamily: 'monospace',
        fontSize: '0.875rem'
      }
    }
  })), /*#__PURE__*/_react.default.createElement(TabPanel, {
    value: tabValue,
    index: 3
  }, preview ? /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "subtitle2",
    gutterBottom: true
  }, _dmsbasereact.intl.get('RenderedSubject').d('Rendered Subject'), ":"), /*#__PURE__*/_react.default.createElement(_material.Paper, {
    variant: "outlined",
    sx: {
      p: 1,
      mb: 2,
      bgcolor: 'grey.50'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body2"
  }, preview.subject)), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "subtitle2",
    gutterBottom: true
  }, _dmsbasereact.intl.get('HTMLPreview').d('HTML Preview'), ":"), /*#__PURE__*/_react.default.createElement(_material.Paper, {
    variant: "outlined",
    sx: {
      p: 2,
      mb: 2,
      maxHeight: 300,
      overflow: 'auto'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: preview.html
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "subtitle2",
    gutterBottom: true
  }, _dmsbasereact.intl.get('TextPreview').d('Text Preview'), ":"), /*#__PURE__*/_react.default.createElement(_material.Paper, {
    variant: "outlined",
    sx: {
      p: 2,
      bgcolor: 'grey.50'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body2",
    sx: {
      whiteSpace: 'pre-wrap',
      fontFamily: 'monospace'
    }
  }, preview.text))) : /*#__PURE__*/_react.default.createElement(_material.Alert, {
    severity: "info"
  }, _dmsbasereact.intl.get('ClickPreviewButton').d('Click the Preview button to see the rendered template')))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      p: 2,
      borderTop: '1px solid #eee',
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsButton, {
    icon: /*#__PURE__*/_react.default.createElement(_Visibility.default, null),
    text: previewLoading ? _dmsbasereact.intl.get('Loading').d('Loading...') : _dmsbasereact.intl.get('Preview').d('Preview'),
    onClick: handlePreview,
    disabled: previewLoading || saving
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      display: 'flex',
      gap: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsButton, {
    icon: /*#__PURE__*/_react.default.createElement(_Cancel.default, null),
    text: _dmsbasereact.intl.get('Cancel').d('Cancel'),
    onClick: onClose,
    disabled: saving
  }), /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsButton, {
    icon: /*#__PURE__*/_react.default.createElement(_Save.default, null),
    text: saving ? _dmsbasereact.intl.get('Saving').d('Saving...') : _dmsbasereact.intl.get('Save').d('Save'),
    onClick: handleSave,
    disabled: saving
  })))));
};

/**
 * EmailTemplates - Main component for email template management
 */
const EmailTemplates = () => {
  const {
    data,
    isLoading,
    refetch
  } = (0, _dmsbasereact.useGet)('/email-templates', null, true);
  const [editModalOpen, setEditModalOpen] = (0, _react.useState)(false);
  const [selectedTemplate, setSelectedTemplate] = (0, _react.useState)(null);
  const handleEdit = (0, _react.useCallback)(template => {
    setSelectedTemplate(template);
    setEditModalOpen(true);
  }, []);
  const handleCloseModal = (0, _react.useCallback)(() => {
    setEditModalOpen(false);
    setSelectedTemplate(null);
  }, []);
  const handleSave = (0, _react.useCallback)(() => {
    handleCloseModal();
    refetch();
  }, [handleCloseModal, refetch]);
  const templates = (data === null || data === void 0 ? void 0 : data.data) || data || [];
  return /*#__PURE__*/_react.default.createElement(_material.Paper, {
    variant: "outlined",
    sx: {
      p: 2
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      mb: 2
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h6"
  }, _dmsbasereact.intl.get('EmailTemplates').d('Email Templates')), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body2",
    color: "text.secondary"
  }, _dmsbasereact.intl.get('EmailTemplatesDescription').d('Manage email templates for system notifications. Edit the subject, HTML content, and plain text content for each template.'))), isLoading ? /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      display: 'flex',
      justifyContent: 'center',
      p: 4
    }
  }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, null)) : templates.length === 0 ? /*#__PURE__*/_react.default.createElement(_material.Alert, {
    severity: "info"
  }, _dmsbasereact.intl.get('NoTemplatesFound').d('No email templates found. Run database fixtures to create default templates.')) : /*#__PURE__*/_react.default.createElement(_material.List, null, templates.map(template => /*#__PURE__*/_react.default.createElement(TemplateListItem, {
    key: template.pk,
    template: template,
    onEdit: handleEdit
  }))), /*#__PURE__*/_react.default.createElement(EditTemplateModal, {
    open: editModalOpen,
    template: selectedTemplate,
    onClose: handleCloseModal,
    onSave: handleSave
  }));
};
exports.EmailTemplates = EmailTemplates;